import { Printer } from "lucide-react";
import { inr, monthLabel, fmtDate, toWordsINR } from "../lib/format";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Wordmark } from "./Wordmark";

const Row = ({ l, v }) => (
  <div className="flex justify-between py-1.5 text-sm"><span className="text-[#6E6E73]">{l}</span><span className="font-semibold tabular-nums">{v}</span></div>
);

export const PayslipDialog = ({ slip, onClose }) => (
  <Dialog open={!!slip} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-3xl max-h-[92vh] overflow-y-auto bg-white" data-testid="payslip-dialog">
      <DialogTitle className="sr-only">Payslip</DialogTitle>
      {slip && (
        <div className="payslip-print p-2 sm:p-4" data-testid="payslip-content">
          <div className="flex items-start justify-between border-b-2 border-[#0A0807] pb-4">
            <div>
              <Wordmark className="text-3xl" />
              <div className="text-sm font-bold mt-1" data-testid="payslip-entity">{slip.entity_legal_name || "MyBev Technologies"}</div>
              <div className="text-xs text-[#6E6E73]">{slip.entity_address || "Gurugram, India"}{slip.entity_cin ? ` · CIN ${slip.entity_cin}` : ""}</div>
            </div>
            <div className="text-right">
              <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#E08A1E]">Payslip</div>
              <div className="text-lg font-extrabold" data-testid="payslip-month">{monthLabel(slip.month)}</div>
            </div>
          </div>
          <div className="grid sm:grid-cols-2 gap-x-8 py-4 border-b border-[#E5E5EA]">
            <Row l="Employee" v={slip.employee_name} /><Row l="Employee ID" v={slip.employee_code} />
            <Row l="Designation" v={slip.designation || "—"} /><Row l="Department" v={slip.department || "—"} />
            <Row l="Date of joining" v={fmtDate(slip.date_of_joining)} /><Row l="PAN" v={slip.pan || "—"} />
            <Row l="UAN" v={slip.uan || "—"} /><Row l="Bank A/c" v={slip.bank_account ? `${slip.bank_account} (${slip.bank_ifsc || "—"})` : "—"} />
            <Row l="Paid days" v={`${slip.paid_days} / ${slip.days_in_month}`} /><Row l="LOP days" v={slip.lop_days} />
          </div>
          <div className="grid sm:grid-cols-2 gap-8 py-4">
            <div>
              <div className="text-xs font-bold uppercase tracking-wider mb-2">Earnings</div>
              <Row l="Basic" v={inr(slip.earnings.basic)} /><Row l="House Rent Allowance" v={inr(slip.earnings.hra)} /><Row l="Special Allowance" v={inr(slip.earnings.special_allowance)} />
              <div className="border-t border-[#E5E5EA] mt-2"><Row l="Gross earnings" v={inr(slip.gross)} /></div>
            </div>
            <div>
              <div className="text-xs font-bold uppercase tracking-wider mb-2">Deductions</div>
              <Row l="Provident Fund" v={inr(slip.deductions.pf)} /><Row l="Professional Tax" v={inr(slip.deductions.professional_tax)} /><Row l="TDS" v={inr(slip.deductions.tds)} />
              <div className="border-t border-[#E5E5EA] mt-2"><Row l="Total deductions" v={inr(slip.total_deductions)} /></div>
            </div>
          </div>
          <div className="rounded-xl bg-[#0A0807] text-white p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-2">
            <div><div className="text-xs uppercase tracking-wider text-neutral-400">Net pay</div><div className="text-xs text-neutral-400 mt-1" data-testid="payslip-words">{toWordsINR(slip.net_pay)}</div></div>
            <div className="text-3xl font-extrabold text-[#E08A1E]" data-testid="payslip-net-pay">{inr(slip.net_pay)}</div>
          </div>
          <p className="text-[11px] text-[#6E6E73] mt-4">This is a system-generated payslip and does not require a signature.</p>
        </div>
      )}
      <div className="flex justify-end no-print">
        <Button onClick={() => window.print()} data-testid="print-payslip-button" className="bg-[#E08A1E] hover:bg-[#C87515] text-white rounded-full"><Printer className="h-4 w-4 mr-2" />Print / Save PDF</Button>
      </div>
    </DialogContent>
  </Dialog>
);
